export var Orientation;
(function (Orientation) {
    Orientation["horizontal"] = "HORIZONTAL";
    Orientation["vertical"] = "VERTICAL";
})(Orientation || (Orientation = {}));
export var Size;
(function (Size) {
    Size["small"] = "SMALL";
    Size["medium"] = "MEDIUM";
    Size["large"] = "LARGE";
})(Size || (Size = {}));
// Style describes the overall presentation of a component.
export var Variant;
(function (Variant) {
    Variant["solid"] = "SOLID";
    Variant["outline"] = "OUTLINE";
    Variant["quiet"] = "QUIET";
    Variant["cta"] = "CTA";
})(Variant || (Variant = {}));
// Scheme describes the desired colour scheme and should match the purpose of a component.
// e.g.
//      Error or warning message: Scheme.error.
//      Call to action: Scheme.brand1 or State.brand2
//      Information: Scheme.info
//      Other UI elements (tooltip icon prompt etc): Scheme.accent1 or Scheme.accent2
export var Scheme;
(function (Scheme) {
    Scheme["default"] = "default";
    Scheme["primary"] = "primary";
    Scheme["shade7"] = "shade7";
    Scheme["shade6"] = "shade6";
    Scheme["shade5"] = "shade5";
    Scheme["shade4"] = "shade4";
    Scheme["shade3"] = "shade3";
    Scheme["shade2"] = "shade2";
    Scheme["shade1"] = "shade1";
    Scheme["secondary"] = "secondary";
    Scheme["success"] = "success";
    Scheme["info"] = "info";
    Scheme["warning"] = "warning";
    Scheme["error"] = "error";
    Scheme["brand1"] = "brand1";
    Scheme["brand2"] = "brand2";
    Scheme["accent1"] = "accent1";
    Scheme["accent2"] = "accent2";
    Scheme["disabled"] = "disabled";
})(Scheme || (Scheme = {}));
//# sourceMappingURL=System.js.map